<!-- display this component when path entered is not assigned -->
<template>
  <section class="message-container">
      <h2 class="secondary-title">
        <font-awesome-icon :icon="['fa-regular', 'fa-face-frown']"/>
        Página não encontrada
      </h2>
      <!-- link to return home-->
      <p>
        <span> Regressar à </span>
        <router-link to="/home">página inicial</router-link>
        <span>.</span>
      </p>
  </section>
</template>